<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar />
    <TheAside />
    <CWrapper>
      <TheHeader />
      <div class="c-body">
        <AutoLogout/>
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <!-- <zoom-center-transition :duration="300" mode="out-in"> -->
              <keep-alive>
                <router-view></router-view>
              </keep-alive>
              <!-- </zoom-center-transition> -->
            </transition>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </CWrapper>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "./TheFooter";
import TheAside from "./TheAside";

import { ZoomCenterTransition } from "vue2-transitions";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside,
    ZoomCenterTransition,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    if (this.user.beats > 0) {
        this.$store.dispatch("heartstart");
      }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      if (window) {
        this.$store.dispatch("resize", {
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
